

export class EmployeeSummaryDto implements IEmployeeSummaryDto {
    id!: number | undefined;
    empName!: string | undefined;
    empCode!: number | undefined;
    userId!: number | undefined;
    readonly displayName!: string | undefined;

    constructor(data?: IEmployeeSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.empName = _data["empName"];
            this.empCode = _data["empCode"];
            this.userId = _data["userId"];
            (<any>this).displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): EmployeeSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["empName"] = this.empName;
        data["empCode"] = this.empCode;
        data["userId"] = this.userId;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IEmployeeSummaryDto {
    id: number | undefined;
    empName: string | undefined;
    empCode: number | undefined;
    userId: number | undefined;
    displayName: string | undefined;
}

